/**
 * Trigger a short haptic vibration for tactile feedback.
 * Falls back silently on devices/browsers that don't support vibration.
 */
export function haptic(durationMs = 10): void {
  try {
    navigator?.vibrate?.(durationMs);
  } catch {
    // Silently ignore — vibration not available
  }
}

/** Slightly stronger haptic for confirmations / important actions */
export function hapticMedium(): void {
  haptic(25);
}

/** Warning / error haptic — longer buzz */
export function hapticError(): void {
  haptic(40);
}
